import React from 'react';
import * as S from './styled';
export const Summary = ({ form, tiers }) => {
    if (!form.values.rules.length) {
        return 'Enter information on the left to see a summary of your rules here.';
    }
    const renderRule = (rule) => {
        if (rule.type === 'CommentsWritten') {
            if (form.values.commentsWrittenMin && form.values.commentsWrittenMax) {
                return `Wrote ${form.values.commentsWrittenMin} to ${form.values.commentsWrittenMax} comments`;
            }
            if (form.values.commentsWrittenMin) {
                return `Wrote at least ${form.values.commentsWrittenMin} comments`;
            }
            return null;
        }
        if (rule.type === 'LikesGiven') {
            if (form.values.likesGivenMin && form.values.likesGivenMax) {
                return `Gave ${form.values.likesGivenMin} to ${form.values.likesGivenMax} likes`;
            }
            if (form.values.likesGivenMin) {
                return `Gave ${form.values.likesGivenMin} likes`;
            }
            return null;
        }
        if (rule.type === 'LikesReceived') {
            if (form.values.likesReceivedMin && form.values.likesReceivedMax) {
                return `Received ${form.values.likesReceivedMin} to ${form.values.likesReceivedMax} likes`;
            }
            if (form.values.likesReceivedMin) {
                return `Received ${form.values.likesReceivedMin} likes`;
            }
            return null;
        }
        if (rule.type === 'Tier') {
            if (rule.tierId) {
                const tier = tiers?.find((tier) => tier.id === rule.tierId);
                return `${tier ? tier.name : rule.tierId} members`;
            }
            return null;
        }
        return null;
    };
    return (React.createElement(S.List, null,
        form.values.rules.map((rule) => {
            const ruleCopy = renderRule(rule);
            if (!ruleCopy)
                return null;
            return React.createElement("li", { key: rule.type }, ruleCopy);
        }),
        form.values.removeWhenRulesNoLongerMet && (React.createElement("li", null, "Remove badge when requirements are no longer met"))));
};
